<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary mt-50">گزارش فروش محصولات</h3>
        <b-row class="mb-2">
            <b-col md="6" lg="2" class="mt-25">
                <b-form-group label="نام محصول" label-for="nameId">
                    <b-form-input v-model="parameters.productName" id="nameId" dir="ltr" autocomplete="off"
                        class="text-center" name="nameId" />
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="تاریخ شروع" label-for="fromId">
                    <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                        :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                        name="fromId" />
                    <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="تاریخ پایان" label-for="toId">
                    <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                        :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                    <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                </b-form-group>
            </b-col>
            <b-col md="4" lg="2" class="mt-25">
                <b-form-group label="ترتیب نمایش" label-for="sortAscendingId">
                    <b-card no-body class="mb-0">
                        <v-select v-model="parameters.sortAscending" :searchable="false" dir="rtl"
                            :options="sortAscending" autocomplete="off" id="sortAscendingId"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-card>
                </b-form-group>
            </b-col>
            <b-col md="4" lg="2" class="mt-25">
                <b-form-group label="نوع سفارش" label-for="typeId">
                    <b-card no-body class="mb-0">
                        <v-select v-model="parameters.type" :searchable="false" dir="rtl" :options="type"
                            autocomplete="off" id="typeId" :reduce="(value) => value.id" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-card>
                </b-form-group>
            </b-col>
            <b-col md="4" lg="2" class="mt-md-2 mt-50">
                <b-button variant="info" @click="productSalesReport" :disabled="loading"
                    class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                    <span>اعمال فیلتر</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
        </b-row>
        <b-card class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="productList.length" responsive :items="productList" :fields="fields" class="mb-0"
                    striped>
                    <template #cell(salesCount)="data">
                        {{ data.item.salesCount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(basePrice)="data">
                        {{ data.item.basePrice.toLocaleString('fa-IR') }}
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="productSalesReport" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BFormInput, BSpinner, BBadge, BFormGroup } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BSpinner,
        BFormInput,
        BBadge,
        BFormGroup,
        vSelect
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            currentDate: '',
            productList: [],
            fields: [
                {
                    key: 'name_Fa',
                    label: 'نام محصول',
                },
                {
                    key: 'basePrice',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'salesCount',
                    label: 'تعداد فروش',
                },
            ],
            type: [
                { id: null, name: 'محاسبه همه' },
                { id: 0, name: 'داخل سالن' },
                { id: 1, name: 'بیرون بر' },
            ],
            sortAscending: [
                { id: true, name: 'صعودی' },
                { id: false, name: 'نزولی' },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                type: null,
                from: null,
                to: null,
                sortAscending: false,
                productName: null
            },
            storeId: null,
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        productSalesReport() {
            this.loading = true
            storeService.productSalesReport(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.productList = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.productList = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.parameters.from = this.formatDate2(today);
        this.parameters.to = this.formatDate2(tomorrow);
        this.currentDate = this.parameters.to;
        this.productSalesReport()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>